import { FC } from 'react';
import { FlexSpacer } from 'ui/flexSpacer';
import { STOBackground } from 'modules/intelligentInsights/stoInsights/STO.styles';
import { STOMainHeader } from 'modules/intelligentInsights/stoInsights/components/STOMainHeader';
import { STOTrendsBase } from 'modules/intelligentInsights/stoInsights/components/stoTrends/STOTrendsBase';
import { STOBreakdownHeader } from 'modules/intelligentInsights/stoInsights/components/breakdownByMedium/STOBreakdownHeader';
import { STOBreakdownTabs } from 'modules/intelligentInsights/stoInsights/components/breakdownByMedium/STOBreakdownTabs';

export const STOMainContent: FC = () => {
  return (
    <STOBackground>
      <FlexSpacer flexDirection="column" gap="double" width="100%">
        <STOMainHeader />
        <STOTrendsBase />
        <STOBreakdownHeader />
        <STOBreakdownTabs />
      </FlexSpacer>
    </STOBackground>
  );
};
